import React, { useEffect, useState } from "react";
import PartnerTable from "./PartnerTable/PartnerTable";
import { useDispatch, useSelector } from "react-redux";
import { findEnquiriedPartnerAction } from "../../actions/partnerAction/partnerEnquiryAction";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { Alert, AlertTitle, Pagination } from "@mui/material";

// material Table
const columns = [
  {
    title: "Sl no",
    field: "sl",
  },
  {
    title: "Partner Name",
    field: "partnerName",
    hidden: false,
  },
  {
    title: "Email",
    field: "email",
    hidden: false,
  },
  {
    title: "Phone     ",
    field: "phone",
    hidden: false,
  },
  {
    title: "Message",
    field: "message",
    hidden: false,
  },
  {
    title: "",
    field: "action",
    filtering: false,
  },
];

function PartnerApproval() {
  const dispatch = useDispatch();

  const [partnerdata, setPartnerData] = useState([]);
  const { privilege, hasPrivilege } = usePrivilegeCheck();
  const [page, setPage] = useState(1)
  const [pagiantionEntry, setPagiantionEntry] = useState(25);

  let { partnerEnquiryFindSuccess } = useSelector((state) => {
    return state.findEnquiriedPartner;
  });
  
  let { partnerEnquiryStatusSuccess } = useSelector((state) => {
    return state.partnerApprovalStatusUpdate;
  });

  useEffect(() => {
    if (partnerEnquiryFindSuccess) {
      setPartnerData(
        partnerEnquiryFindSuccess?.payload?.map((item) => ({
          id: item.id,
          column1: item.name,
          column2: item.email,
          column3: item.phone,
          column4: item.message,
          status: item.status,
        }))
      );
    }
  }, [partnerEnquiryFindSuccess]);

  useEffect(() => {
    dispatch(findEnquiriedPartnerAction(pagiantionEntry, page));
  }, [dispatch, partnerEnquiryStatusSuccess, pagiantionEntry, page]);

  const handleChangePage = (event, newPage) => {
    try {
      setPage(newPage)
    } catch(error) {
      console.error(error);
    }
  }


  if (!hasPrivilege("Partner approvel") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  console.log(hasPrivilege("Partner approvel"),"hasPrivilegehasPrivilege")

  return (
    <>
      <PartnerTable
        columns={columns}
        data={partnerdata}
        component="partnerEnquiry"
        subMenu="Partner approvel"
        pagiantionEntry={pagiantionEntry}
        paginationPageNumber={page}
      />

      <Pagination
        sx={{
          mt: "28px",
          "& .Mui-selected": {
            backgroundColor: "#f81b82 !important",
            color: "#fff"
          },
          "& .MuiPagination-ul": {
            justifyContent: "end"
          }
        }}
        component="div"
        count={Math.ceil(partnerEnquiryFindSuccess?.totalCount / pagiantionEntry)}
        page={ page }
        onChange={handleChangePage}
      />
    </>
  );
}

export default PartnerApproval;
